var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7487 6.28589V7.21198C11.7487 8.07986 11.0452 8.78341 10.1773 8.78341H4.85712V12.9066C4.85712 13.516 5.35115 14.01 5.96056 14.01H11.7537L13.6792 15.9355C13.7615 16.02 13.8883 16.0428 13.9949 15.9924C14.1014 15.9419 14.1641 15.8293 14.1509 15.7121L13.9606 14.01H14.7882C15.3976 14.01 15.8916 13.516 15.8916 12.9066V7.38934C15.8916 6.77992 15.3976 6.28589 14.7882 6.28589H11.7487Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99999 1.54329V6.40207C9.99999 6.93875 9.56507 7.37382 9.02856 7.37382H3.92856L2.23342 9.06953C2.16099 9.14392 2.0493 9.16402 1.95549 9.11957C1.86168 9.07512 1.80648 8.97594 1.81813 8.87275L1.98571 7.37382H1.25713C0.720629 7.37382 0.285706 6.93875 0.285706 6.40207V1.54329C0.285706 1.0066 0.720629 0.571533 1.25713 0.571533H9.02856C9.56507 0.571533 9.99999 1.0066 9.99999 1.54329ZM2.42856 4.57153C2.82305 4.57153 3.14285 4.25174 3.14285 3.85725C3.14285 3.46276 2.82305 3.14296 2.42856 3.14296C2.03407 3.14296 1.71428 3.46276 1.71428 3.85725C1.71428 4.25174 2.03407 4.57153 2.42856 4.57153ZM5.71428 3.85725C5.71428 4.25174 5.39448 4.57153 4.99999 4.57153C4.6055 4.57153 4.28571 4.25174 4.28571 3.85725C4.28571 3.46276 4.6055 3.14296 4.99999 3.14296C5.39448 3.14296 5.71428 3.46276 5.71428 3.85725ZM7.57142 4.57153C7.96591 4.57153 8.28571 4.25174 8.28571 3.85725C8.28571 3.46276 7.96591 3.14296 7.57142 3.14296C7.17693 3.14296 6.85713 3.46276 6.85713 3.85725C6.85713 4.25174 7.17693 4.57153 7.57142 4.57153Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 8,
    height: 2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.19150a4c.svg";
export { ForwardRef as ReactComponent };